import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { isEqual, keyBy, merge } from "lodash";

import Graph_QL, { DynamicDataObk } from "../..";
import { DeviceInfo } from "../GQLCalls/getDeviceInfoCall";
import { DeviceRegister } from "../GQLCalls/getDeviceRegistersCall";


export type DeviceInfoItem = DynamicDataObk<DeviceInfo[]> & {cpuOptions?: DeviceRegister[]}

const deviceInfoDataAdapter = createEntityAdapter({
  selectId: (item: DeviceInfoItem) => Graph_QL.ObjToString(item.con)
});

const mergePayloadAndState = (state: EntityState<DeviceInfoItem, string>, {con, data, cpuOptions}: DeviceInfoItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "device_id")
    data.forEach((entry) => dataDictionary[entry.device_id] = entry)
    const newPayload = {con, data: Object.values(dataDictionary), cpuOptions: Object.values(merge({}, keyBy(state.entities[identifier].cpuOptions, "device_register_id"), keyBy(cpuOptions, "device_register_id")))}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) || cpuOptions?.length ) {
      deviceInfoDataAdapter.upsertOne(state, newPayload);
    }
  } else { deviceInfoDataAdapter.addOne(state, {con, data, cpuOptions: cpuOptions ?? []})}
}

const deviceInfoSlice = createSlice({
  name: "deviceInfo",
  initialState: deviceInfoDataAdapter.getInitialState(),
  reducers: {
    maintained: (state, {payload}:PayloadAction<DeviceInfoItem>) => {
      mergePayloadAndState(state, payload);
    },
  }
})

export const DeviceInfoActions = deviceInfoSlice.actions;
export default deviceInfoSlice.reducer;